var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59389 4.18899C5.67564 1.72553 8.13188 0 11 0C14.5574 0 17.4945 2.65293 17.9412 6.08846C20.2526 6.52879 22 8.56045 22 11C22 13.7613 19.7613 16 17 16H6C2.68672 16 0 13.3133 0 10C0 7.16606 1.96603 4.82094 4.59389 4.18899ZM11 2C8.80568 2 6.94247 3.41652 6.27066 5.39023C6.14863 5.74875 5.83452 6.00758 5.45928 6.05881C3.50166 6.32608 2 7.98404 2 10C2 12.2087 3.79128 14 6 14H17C18.6567 14 20 12.6567 20 11C20 9.34328 18.6567 8 17 8C16.4477 8 16 7.55228 16 7C16 4.23828 13.7617 2 11 2ZM11 5C11.5523 5 12 5.44772 12 6V9.33C12 9.88228 11.5523 10.33 11 10.33C10.4477 10.33 10 9.88228 10 9.33V6C10 5.44772 10.4477 5 11 5ZM11 13C11.5523 13 12 12.5523 12 12C12 11.4477 11.5523 11 11 11C10.4477 11 10 11.4477 10 12C10 12.5523 10.4477 13 11 13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudAlert);
export default __webpack_public_path__ + "static/media/cloud-alert.06d22dde226b265fee09bd543acc63b4.svg";
export { ForwardRef as ReactComponent };